import { AppInstanceType } from 'src/app/model/app-instance-type';
export class MenuEntry {
    title: string;
    instanceType: string;
    description: string;
    icon: string;
    constructor(title: string,instanceType: string, icon?: string, description?: string) {
        this.title = title;
        this.instanceType = instanceType;
        if (icon) {
            this.icon = icon;
        }
        if (description) {
            this.description = description;
        }
    }
}